import { useLanguage } from "@/i18n";
import { scrollToId } from "@/pages/Landing";

export const Footer = ({ settings }) => {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-white/10 px-4 sm:px-8 lg:px-16 pt-16 pb-8" data-testid="site-footer">
      <button onClick={() => scrollToId("#top")} data-testid="footer-logo"
        className="font-display uppercase text-[14vw] sm:text-[10vw] leading-[0.85] tracking-wider text-outline hover:text-white hover:[-webkit-text-stroke:0] transition-all duration-700 text-left">
        {settings.studio_name || "STUDIO"}
      </button>
      <div className="mt-12 border-t border-white/10 pt-6">
        <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-zinc-500">
          © {new Date().getFullYear()} {settings.studio_name} — {t("footer_rights")}
        </p>
      </div>
    </footer>
  );
};
